// import BadgeLink from '@/components/BadgeLink.vue'
import type { TableColumn } from '@/components/alerts/types'
import EyeButton from '@/components/EyeButton.vue'
import type { DexAlertResponse } from '@/services/alerts-v2-service/types'
import { getDexUrl, getTradeUrl } from '@/utils'
// import { getGmgnUrl, getTradeUrl } from '@/utils'
// import Badge from 'primevue/badge'
import { markRaw } from 'vue'
import { useRouter } from 'vue-router'
// import { useRouter } from 'vue-router'

export const getSeverityByVol24 = (vol24h: number) => {
  if (vol24h <= 500000) {
    return 'danger'
  } else if (vol24h <= 1000000) {
    return 'warn'
  } else {
    return 'success'
  }
}

export const getDexCexProTableColumns = (): TableColumn[] => {
  const router = useRouter()
  return [
    {
      field: 'symbol.name',
      header: 'table.asset',
      width: '120px',
      skeletonWidth: '70px',
      class: 'text-left',
      dynamic: true,
      inner: 'a',
      innerPropsGenerator: (v: object) => {
        const data = v as DexAlertResponse
        const asset = data.symbol.name.split('/')[0] as string
        const href = router.resolve({
          name: 'eye-all-asset',
          params: {
            asset: asset,
          },
        }).fullPath
        return {
          target: '_blank',
          href: href,
          class: 'pit hover',
        }
      },
    },

    {
      field: 'spread',
      width: '85px',
      header: 'table.spread',
      // sortable: true,
      class: 'text-center',
      skeletonWidth: '70px',
      dynamic: true,
      inner: 'span',
      innerPropsGenerator: (v: object) => {
        const data = v as DexAlertResponse
        const myClass = data.spread && data.spread > 0 ? 'success' : 'error'
        return {
          class: `pit digit ${myClass}`,
        }
      },
    },

    // Покупка
    {
      field: 'ex_buy',
      width: '110px',
      header: 'table.exBuy',
      class: 'text-right capitalize',
      skeletonWidth: '70px',
      dynamic: true,
      inner: 'a',
      innerPropsGenerator: (v: object) => {
        const data = v as DexAlertResponse
        const asset = data.symbol.name.split('/')[0] as string
        const href = data.is_cex_long
          ? getTradeUrl(data.ex_buy, asset, true)
          : getDexUrl(data.dex, data.chain_name ?? 'bep20', data.contract)
        return {
          target: '_blank',
          rel: 'noreferrer',
          href: href,
          class: 'pit success hover',
        }
      },
      // dynamic: true,
      // inner: markRaw(BadgeLink),
      // innerPropsGenerator: (data: object) => {
      //   const fgData = data as DexAlertResponse
      //   const href = fgData.is_cex_long
      //     ? getTradeUrl(fgData.ex_buy, fgData.symbol?.name?.split('/')[0] ?? 'BTC', true)
      //     : getGmgnUrl(fgData.chain_name, fgData.contract)
      //   return {
      //     severity: 'success',
      //     href: href,
      //   }
      // },
    },
    {
      dynamic: true,
      field: 'vol24h_buy',
      width: '105px',
      header: 'table.vol24h',
      class: 'text-left hidden md:table-cell lg:text-center',
      skeletonWidth: '70px',
      inner: 'span',
      innerPropsGenerator: (v: object) => {
        const data = v as DexAlertResponse
        const myClass = getSeverityByVol24(data.vol24h_buy)
        return {
          class: `pit digit ${myClass}`,
        }
      },
    },
    {
      field: 'price_buy',
      width: '115px',
      header: 'table.price',
      class: 'text-left hidden lg:table-cell',
      skeletonWidth: '70px',
      inner: 'span',
      innerProps: {
        class: 'pit digit',
      },
    },

    // Продажа
    {
      field: 'ex_sell',
      width: '110px',
      header: 'table.exSell',
      class: 'text-left capitalize md:text-right',
      skeletonWidth: '70px',
      dynamic: true,
      inner: 'a',
      innerPropsGenerator: (v: object) => {
        const data = v as DexAlertResponse
        const asset = data.symbol.name.split('/')[0] as string
        const href = !data.is_cex_long
          ? getTradeUrl(data.ex_sell, asset, true)
          : getDexUrl(data.dex, data.chain_name ?? 'bep20', data.contract)
        return {
          target: '_blank',
          rel: 'noreferrer',
          href: href,
          class: 'pit error hover',
        }
      },
      // inner: markRaw(BadgeLink),
      // innerPropsGenerator: (data: object) => {
      //   const fgData = data as DexAlertResponse
      //   const href = !fgData.is_cex_long
      //     ? getTradeUrl(fgData.ex_sell, fgData.symbol?.name?.split('/')[0] ?? 'BTC', true)
      //     : getGmgnUrl(fgData.chain_name, fgData.contract)
      //   return {
      //     severity: 'danger',
      //     href: href,
      //   }
      // },
    },
    {
      dynamic: true,
      field: 'vol24h_sell',
      width: '105px',
      skeletonWidth: '70px',
      header: 'table.vol24h',
      class: 'text-left hidden md:table-cell lg:text-center',
      inner: 'span',
      innerPropsGenerator: (v: object) => {
        const data = v as DexAlertResponse
        const myClass = getSeverityByVol24(data.vol24h_sell)
        return {
          class: `pit digit ${myClass}`,
        }
      },
    },
    {
      dynamic: true,
      field: 'price_sell',
      width: '115px',
      skeletonWidth: '70px',
      header: 'table.price',
      class: 'text-left hidden lg:table-cell',
      inner: 'span',
      innerProps: {
        class: 'pit digit',
      },
    },
    // {
    //   field: 'pool',
    //   header: 'table.pool',
    //   class: 'text-center w-20 hidden xl:table-cell',
    //   inner: markRaw(Badge),
    //   innerProps: {
    //     severity: 'info',
    //   },
    // },
    // {
    //   field: 'vol1h_dex',
    //   header: 'table.vol1hDex',
    //   class: 'text-center w-40',
    //   inner: markRaw(Badge),
    //   innerProps: {
    //     severity: 'info',
    //   },
    // },
    // {
    //   field: 'trades1h_dex',
    //   header: 'table.trades1hDex',
    //   class: 'text-center w-40',
    //   inner: markRaw(Badge),
    //   innerProps: {
    //     severity: 'info',
    //   },
    // },
    {
      field: 'updated_at',
      width: '150px',
      header: 'table.timeAgo',
      class: 'text-center',
      skeletonWidth: '70px',
      sortable: true,
      dynamic: true,
      inner: 'span',
      innerProps: {
        class: 'pit digit',
      },
    },
    {
      dynamic: true,
      field: '',
      width: '50px',
      skeletonWidth: '70px',
      header: '',
      class: 'text-center collapser-class',
      noPadding: true,
      inner: markRaw(EyeButton),
      innerPropsGenerator: (data: object) => {
        const swapData = data as DexAlertResponse
        return {
          name: `eye-dex-asset-long`,
          params: {
            marketType: swapData.is_cex_spot ? 'spot' : 'swap',
            chain: swapData.chain_name ?? 'bep20',
            asset: swapData.symbol?.name?.split('/')[0] ?? '0x00',
            cex: swapData.cex?.name ?? 'mexc',
            amount: 20,
          },
        }
      },
    },
  ]
}
